import { useEffect, useState } from 'react';

/**
 * Renvoie `valeur` après `delaiMs` de stabilité.
 *
 * Les barres de recherche du back-office écrivent leur terme dans l'URL, qui pilote la clé de
 * requête : sans amortissement, taper « GVZ-2026-000137 » déclenche quinze requêtes de stock et
 * quinze entrées d'historique de navigation, dont quatorze sont périmées avant d'être reçues.
 * L'amortissement est côté client uniquement — il ne remplace ni la pagination par curseur ni la
 * limitation de débit du serveur.
 */
export function useDifferer<T>(valeur: T, delaiMs = 350): T {
  const [differee, setDifferee] = useState<T>(valeur);

  useEffect(() => {
    const minuteur = window.setTimeout(() => {
      setDifferee(valeur);
    }, delaiMs);
    return () => {
      window.clearTimeout(minuteur);
    };
  }, [valeur, delaiMs]);

  return differee;
}
